<template>
  <div>
    <div class="page-header-class">
      <el-page-header @back="close" content="回复"> </el-page-header>
    </div>
    <el-tabs
      v-model="activeDefault"
      @tab-click="handleClick"
      tab-position="left"
    >
      <el-tab-pane
        v-for="(item, index) in scope"
        :key="index"
        :label="(index + 1).toString()"
        :value="item"
        :name="item.messageId"
      >
        <commonTable
          :rowKey="'sku'"
          :tableData="tableDataOrderList"
          :tableLabel="tableLabelOrder"
          :isPage="false"
          :tableOption="tableOrderOption"
          style="margin-bottom: 15px"
        >
          <!-- v-if="$buttonAuthority(allButton, 'resend')" -->
          <template slot-scope="data">
            <el-button
              size="mini"
              type="text"
              :disabled="data.row.orderNo !== '' ? false : true"
              @click="applyClick(data.row)"
              >发起退款</el-button
            >
          </template>
        </commonTable>
        <div :id="'tabClass_' + index">
          <div v-loading="loading">
            <div class="handle_class">
              <div class="imgReceipt rightClass">
                <div class="header-info">
                  <h2>{{ leftEmailObj.subject }}</h2>
                  <h4>发件人：{{ leftEmailObj.sender }}</h4>
                  <h4>收件人：{{ leftEmailObj.sendToName }}</h4>
                </div>
                <div class="header-info">
                  <!-- @click="getimgsrc($event)" -->
                  <div v-html="leftEmailObj.text"></div>
                </div>
                <div class="border-box" v-show="imgSrc.length > 0">
                  <p class="font-annex">
                    <i class="el-icon-paperclip"></i>附件
                  </p>
                  <viewer style="display: flex" :images="imgSrc">
                    <img
                      class="img-annex"
                      v-for="(src, i) in imgSrc"
                      :src="src"
                      :key="i"
                    />
                  </viewer>
                </div>
              </div>
              <div class="email_class" style="font-size: 12px; cursor: pointer">
                <el-card
                  class="box-card"
                  v-for="(item, index) in dataList"
                  :key="index"
                >
                  <div slot="header" class="clearfix">
                    <span>
                      <i v-if="item.isRead == 0" class="el-icon-message"></i
                      ><i v-else class="el-icon-finished"></i
                    ></span>
                  </div>
                  <div
                    class="all-class"
                    :class="{ 'active-class': item.isActive }"
                    @click="openHtml(index)"
                  >
                    <p>发件人：{{ item.sender }}</p>
                    <p>收件人：{{ item.sendToName }}</p>
                    <p>邮件标题：{{ item.subject }}</p>
                    <p>
                      邮件状态：<el-button
                        type="text"
                        :disabled="item.isReply != 0"
                        @click="reply(item.id, index)"
                      >
                        设置回复</el-button
                      >
                    </p>
                    <p>物品编码：{{ item.itemId }}</p>
                    <p>
                      新讯息寄件人：<span v-html="item.textContent"></span>
                      <el-button
                        style="margin-left: 30px"
                        type="primary"
                        @click="open"
                        >回复</el-button
                      >
                    </p>
                  </div>

                  <div class="bottom clearfix">
                    <span>{{ item.receiveDate }}</span>
                  </div>
                </el-card>
              </div>
            </div>
            <div :id="'see' + index">
              <div v-if="!isEaby">
                <div class="imgReceipt" style="text-align: center">
                  <el-button
                    icon="el-icon-more"
                    v-if="!isOpenMore"
                    @click="openMore()"
                    >点击展开完整模式</el-button
                  >
                  <el-button icon="el-icon-more" v-else @click="openMore()"
                    >恢复简易模式</el-button
                  >
                </div>
                <div v-if="isOpenMore" style="margin-top: 15px">
                  <!-- 查看备注 -->
                  <span>1.备注信息</span>
                  <!-- 表格 -->
                  <commonTable
                    ref="multipleTable"
                    :tableData="tableData"
                    :tableLabel="tableLabel"
                    :isPage="false"
                    :tableOption="tableOption"
                    @handleButton="handleButton"
                    style="margin-bottom: 15px"
                  ></commonTable>
                  <div>
                    <el-form
                      :model="dataObj"
                      size="small"
                      ref="ruleForm"
                      label-position="right"
                      label-width="110px"
                      style="margin-top: 20px"
                    >
                      <el-form-item label="收件人" prop="recipients">
                        <el-input
                          v-model="dataObj.recipients"
                          placeholder="请输入"
                          class="input-width-two"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="邮件主题" prop="subject">
                        <!-- <el-input
                          v-model="dataObj.subject"
                          placeholder="请输入"
                          class="input-width-two"
                        ></el-input> -->
                        <el-autocomplete
                          style="width: 800px"
                          v-model="dataObj.subject"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @change="setIntoStorage"
                          clearable
                        ></el-autocomplete>
                      </el-form-item>
                      <el-form-item label="操作" prop="templateId">
                        <el-select
                          v-model="dataObj.templateId"
                          clearable
                          filterable
                          placeholder="请选择"
                          class="input-width-two"
                          @change="changeTemplate"
                        >
                          <el-option
                            v-for="(item, index) in templateList"
                            :label="item.name"
                            :value="$downToInteger(item.id)"
                            :key="index"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="正文" prop="content">
                        <el-input
                          v-model="dataObj.content"
                          placeholder="请输入"
                          type="textarea"
                          :ref="'content' + index"
                          style="width: 60%"
                          :rows="8"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="备注" prop="remark">
                        <el-input
                          v-model="dataObj.remark"
                          placeholder="请输入"
                          :rows="2"
                          type="textarea"
                          style="width: 60%"
                        ></el-input>
                        <el-button
                          style="margin-left: 15px"
                          type="primary"
                          @click="saveRemark()"
                          >保存备注</el-button
                        >
                      </el-form-item>
                      <el-form-item>
                        <div class="handle_class">
                          <el-button
                            type="primary"
                            style="margin-left: 20px"
                            @click="send()"
                            >发送</el-button
                          >
                          <el-button
                            type="primary"
                            style="margin-left: 20px"
                            @click="saveSlide"
                            >存为草稿</el-button
                          >
                          <upload
                            buttonName="上传附件"
                            :url="url"
                            :param="uploadObj"
                            style="margin-left: 20px"
                            :text="text"
                            @getImgName="getImgName"
                          ></upload>
                          <el-tag
                            style="margin-left: 20px"
                            v-show="imgName.length > 0 && isIMg"
                            :key="index"
                            v-for="(item, index) in imgName"
                            closable
                            size="medium"
                            :disable-transitions="false"
                            @close="handleDel(item, index)"
                          >
                            <i class="el-icon-document"></i>
                            <span>{{ item }}</span>
                          </el-tag>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div v-else style="margin-top: 15px">
                  <div>
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="dataObj.content"
                      :ref="'content' + index"
                      style="width: 60%"
                    >
                    </el-input>
                    <el-button
                      type="primary"
                      style="margin-left: 20px"
                      @click="send()"
                      >回复</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div v-if="editShow">
        <edit
          :scope="remarkObj"
          @getList="getRemarkList"
          @isShowEdit="isShowEdit"
        ></edit>
      </div>
      <div v-if="lookShow">
        <look :scope="lookObj" @isShowEdit="isShowEdit"></look>
      </div>
      <imgView
        :dialog.sync="isShowImg"
        :imgList="imgView_msg.list"
        :imgIndex="imgView_msg.index"
      ></imgView>
      <applyRefund
        v-if="isRefund"
        @isShowEdit="closeApply"
        @getList="init"
        :platform="platform"
        :orderID="orderID"
      ></applyRefund>
      <el-button
        v-if="isBottom"
        @click="toBottom"
        size="medium"
        circle
        class="to-bottom"
        icon="el-icon-caret-bottom"
      ></el-button>
    </div>
  </div>
</template>

<script>
/**
 * eBay 邮件详情/回复大组件
 * 功能：多邮件 Tab 批量回复，邮件正文/往来消息展示，订单信息与明细（可发起退款、查看产品资料），
 *       备注列表增删改（orderRemarkList/addorderRemark/orderRemarkDelete），草稿/已发送邮件回显，
 *       模板选择、附件上传删除，回复后标记已读
 */
import {
  orderRemarkList,
  replyMessageInfo,
  markMessageRead,
  markMessageReply,
  addorderRemark,
  orderRemarkDelete,
  ebayMessageDraftSave,
  sendMessage,
  getEbayMessage,
  delImg,
  getEbayOrderInfo,
} from "@/api/user";
import edit from "./editRemark";
import look from "./look";
import imgView from "./imgView";
import applyRefund from "../../../afterSale/components/applyRefund";
export default {
  props: {
    scope: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isEaby: {
      type: Boolean,
      default: false,
    },
  },
  components: { edit, look, imgView, applyRefund },
  data() {
    return {
      // 是否打开发起退款弹窗
      isRefund: false,
      platform: 2, // ebay平台id
      // 发起退款的订单号
      orderID: "",
      activeName: "second",
      // 页面加载状态
      loading: true,
      dialogFormVisible: true,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否展开完整模式
      isOpenMore: false,
      // 是否打开备注编辑弹窗
      editShow: false,
      // 是否打开产品资料弹窗
      lookShow: false,
      // 是否显示返回底部按钮
      isBottom: false,
      // 备注列表数据
      tableData: [],
      // 备注表格列定义
      tableLabel: [],
      // 产品资料弹窗参数（sku）
      lookObj: {},
      // 上传附加参数
      uploadObj: {},
      textarea: "",
      // 当前激活的邮件 Tab
      activeDefault: "",
      text: "messageId",
      // 附件上传地址
      url: "/common/upload/uploadFileToEbay",
      // 订单明细数据
      tableDataOrderList: [],
      // 模板列表
      templateList: [],
      tableLabelOrder: [
        {
          label: "订单号",
          param: "orderNo",
          align: "center",
          show: true,
        },
        {
          label: "收件人",
          param: "userName",
          align: "center",
          show: true,
        },
        {
          label: "配货状态",
          param: "orderStatus",
          align: "center",
          show: true,
        },
        {
          label: "物流跟踪号",
          param: "trackingNumber",
          align: "center",
          show: true,
        },
        {
          label: "物流方式",
          param: "logisticsName",
          align: "center",
          show: true,
        },
        {
          label: "时间",
          param: "addTime",
          align: "center",
          show: true,
          render: (h, param) => {
            let addTime = h("p", "成交时间：" + param.row.addTime);
            let payTime = h("p", "添加时间：" + param.row.payTime);
            let shippingTime = h("p", "发货时间：" + param.row.shippingTime);
            return h("div", [addTime, payTime, shippingTime]);
          },
        },
        {
          label: "sku",
          param: "account_name",
          align: "center",
          show: true,
          render: (h, param) => {
            return h(
              "span",
              {
                style: {
                  color: "rgb(64, 158, 255)",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.lookObj.sku = param.row.sku;
                    this.lookShow = true;
                  },
                },
              },
              param.row.sku
            );
          },
        },
        {
          label: "产品数量",
          param: "qty",
          align: "center",
          show: true,
        },
        {
          label: "订单总价",
          param: "orderAmount",
          align: "center",
          show: true,
        },
        {
          label: "eaby账号",
          param: "account_name",
          align: "center",
          show: true,
          render: (h, param) => {
            let payId = h("p", "付款ID：" + param.row.payId);
            let accountName = h("p", "付款账号：" + param.row.accountName);
            return h("div", [payId, accountName]);
          },
        },
      ],
      titleMap: [],
      renderList: {},
      // 往来消息列表
      dataList: [],
      // 备注编辑弹窗数据
      remarkObj: {},
      // 回复邮件表单数据：主题、订单号、备注、正文、草稿/消息/账号/模板 id、收发件人
      dataObj: {
        subject: "",
        orderNo: "",
        remark: "",
        content: "",
        draftId: "",
        messageId: "",
        accountId: "",
        templateId: "",
        sender: "",
        recipients: "",
      },
      // 当前展示的邮件详情
      leftEmailObj: {},
      // 待标记已读的消息 id 列表
      setReadList: [],
      // 待标记已回复的消息 id 列表
      setReplyList: [],
      // 当前回复的消息下标
      nowIndexReply: 0,
      // 当前置已读的消息下标
      nowIndexRead: 0,
      // 当前激活的 Tab 下标
      tabIndex: 0,
      // 草稿 id
      draftId: "",
      // 是否草稿邮件
      isDraft: false,
      // 已发送邮件 id
      sendId: "",
      // 是否已发送邮件
      isSend: false,
      // 当前 Tab 的正文输入框 ref 名
      refName: "",
      // 备注列表分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 备注表格操作列定义（编辑、删除）
      tableOption: {
        label: "操作",
        minWidth: "100",
        fixed: "right",
        options: [
          {
            label: "编辑",
            type: "text",
            methods: "edit",
            size: "mini",
          },
          {
            label: "删除",
            type: "text",
            methods: "delete",
            size: "mini",
          },
        ],
      },
      // 订单明细表格操作列定义（发起退款）
      tableOrderOption: {
        label: "操作",
        width: "110",
        fixed: "right",
      },
      // 是否打开图片查看弹窗
      isShowImg: false,
      // 邮件附件图片地址列表
      imgSrc: [],
      imgList: [],
      imgView_msg: {
        show: false, //是否打开图片查看
        index: 0, //图片查看下标
        list: [], //图片列表
      },
      imgName: [], //上传成功的图片名称
      messageId: "", // 消息id
      // 图片上传成功标记
      isIMg: false,
      // 上传地址
      UploadingUrl: "",
    };
  },
  mounted() {
    // 页面挂载时拉取账号下拉并初始化当前邮件数据
    this.$store.dispatch("getDropListTwo", ["ebayAccountList"]);
    this.init();
  },
  created() {
    // 监听页面滚动，用于显示返回底部按钮
    window.addEventListener("scroll", this.watchScroll, true);
  },
  computed: {
    dropList: {
      get() {
        return this.$store.getters.dropList;
      },
    },
  },
  methods: {
    /** 监听滚动位置，超过阈值时显示返回底部按钮 */
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.querySelector(".scroll").scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 20) {
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
    },
    /** 滚动到页面底部 */
    toBottom() {
      let top = document.querySelector(".scroll").scrollHeight;
      document.querySelector(".scroll").scrollTop = top;
    },
    querySearch(queryString, cb) {
       // 调用 callback 返回建议列表的数据
      let arr = this.$getStorage("ebayTitle");
      let newArr = [];
      let results = [];
      if (arr && arr.length > 0) {
        results = arr.filter((item) => {
          return item.value.includes(queryString);
        });
        // 限制最多显示8条
        if (results.length > 8) {
          newArr = results.slice(0, 8);
        } else {
          newArr = results;
        }
      }
      return cb(newArr);
    },
    setIntoStorage(val) {
      let strArr = [];
      if (val && val !== "") {
        strArr.push({
          value: val,
        });
        // 获取已存在的记录
        let history = this.$getStorage("ebayTitle");
        if (history && history.length > 0) {
          let arr = history.map((item) => item.value);
          if (arr.indexOf(val) > -1) {
            // 判断是否已有此条查询记录，若已存在，则不需再存储
            return;
          }
          //  把搜索记录存入localStorage
          this.$setStorage(
            "ebayTitle",
            strArr.concat(this.$getStorage("ebayTitle"))
          );
        } else {
          // 首次创建
          this.$setStorage("ebayTitle", strArr);
        }
      }
    },
    /** 关闭退款弹窗 */
    closeApply() {
      this.isRefund = false;
    },
    // 发起退款
    applyClick(row) {
      this.isRefund = true;
      this.orderID = row.orderNo;
    },
    /** 滚动到回复编辑区并聚焦当前 Tab 的正文输入框 */
    open() {
      document.getElementById("see" + this.tabIndex).scrollIntoView();
      this.$nextTick(() => {
        this.$refs[this.refName][0].focus();
      });
    },
    /** 备注分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getRemarkList();
    },
    /** 备注页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getRemarkList();
    },
    /** 选择模板时回填正文内容 */
    changeTemplate(value) {
      this.templateList.forEach((element) => {
        if (element.id == value) {
          this.dataObj.content = element.content;
        }
      });
    },
    /** 切换邮件 Tab 时重新初始化当前邮件数据 */
    handleClick(tab, event) {
      this.tabIndex = tab.index;
      this.init();
    },
    /** 将当前回复内容存为草稿 */
    saveSlide() {
      let param = {
        messageId: this.messageId,
        accountId: this.dataList[this.nowIndexReply].accountId,
        content: this.dataObj.content,
        id: this.draftId,
        subject: this.dataObj.subject,
        sender: this.dataObj.sender,
        recipients: this.dataObj.recipients,
      };
      if (this.isDraft) {
        param.id = this.scope[this.tabIndex].id;
      }
      ebayMessageDraftSave(param)
        .then((result) => {
          if (result.code == 200) {
            this.$message.success("保存成功");
            this.draftId = result.data;
          }
        })
        .catch((err) => {});
    },
    /** 保存订单备注 */
    saveRemark() {
      let param = {
        orderNo: this.dataObj.orderNo,
        remark: this.dataObj.remark,
      };
      addorderRemark(param)
        .then((result) => {
          if (result.code == 200) {
            this.$message.success(result.msg);
            this.getRemarkList();
          }
        })
        .catch((err) => {});
    },
    /** 切换展开完整模式/简易模式 */
    openMore() {
      if (this.isOpenMore) {
        this.isOpenMore = false;
        this.$nextTick(() => {
          this.$refs[this.refName][0].focus();
        });
      } else {
        this.isOpenMore = true;
        this.$nextTick(() => {
          this.$refs[this.refName][0].focus();
        });
      }
    },
    /** 批量标记消息为已读 */
    setRead(value) {
      let param = {
        ids: this.setReadList,
        isRead: 1,
      };
      markMessageRead(param)
        .then((result) => {
          if (result.code == 200) {
            this.dataList[this.nowIndexRead].isRead = 1;
          }
        })
        .catch((err) => {});
    },
    /** 批量标记消息为已回复 */
    setReply(value) {
      let param = {
        ids: this.setReplyList,
      };
      markMessageReply(param)
        .then((result) => {
          if (result.code == 200) {
            this.dataList[this.nowIndexReply].isReply = 1;
          }
        })
        .catch((err) => {});
    },
    /** 点击"设置回复"时记录下标并标记该消息已回复 */
    reply(value, index) {
      this.nowIndexReply = index;
      this.messageId = this.dataList[index].messageId;
      this.uploadObj.messageId = this.dataList[index].messageId;
      this.setReplyList = [];
      this.setReplyList.push(value);
      this.setReply();
    },
    /** 发送回复邮件（单邮件发送后关闭，多邮件发送后移除当前 Tab） */
    send() {
      this.dataObj.messageId = this.messageId;
      sendMessage(this.dataObj)
        .then((result) => {
          if (result.code == 200) {
            this.$message.success("发送成功");
            this.dataObj.content = "";
            if (this.scope.length == 1) {
              this.close();
            } else {
              this.scope.splice(this.nowIndexReply, 1);
              if (this.scope.length > 0) {
                this.activeDefault = this.scope[0].messageId;
              }
              this.init();
            }
          }
        })
        .catch((err) => {});
    },
    openHtml(index) {
      this.draftId = "";
      this.leftEmailObj = this.dataList[index];
      this.dataList.forEach((element) => {
        element.isActive = false;
      });
      this.dataList[index].isActive = true;
      //展示就修改状态为已读
      this.nowIndexRead = index;
      this.nowIndexReply = index;
      this.setReadList = [];
      this.setReadList = [this.dataList[index].id];
      this.uploadObj.messageId = this.dataList[index].messageId;
      this.messageId = this.dataList[index].messageId;
      this.setRead();
    },
    init() {
      if (
        this.scope[this.tabIndex].draftId &&
        this.scope[this.tabIndex].draftId != ""
      ) {
        this.isDraft = true;
      }
      if (
        this.scope[this.tabIndex].sendId &&
        this.scope[this.tabIndex].sendId != ""
      ) {
        this.isSend = true;
      }
      this.activeDefault = this.scope[this.tabIndex].messageId;
      this.messageId = this.scope[this.tabIndex].messageId;
      Object.assign(this.pagination, this.dataObj);

      this.setReadList = [this.scope[this.tabIndex].id];
      this.setRead();

      if (this.isEaby) {
        this.getEbayMessage();
      } else {
        this.getReplyInfo();
      }
      this.getOrder();
      this.dataObj.content = "";
      this.dataObj.remark = "";
      this.dataObj.templateId = "";
      this.$store.dispatch("getDropListTwo", ["ebayAccountList"]);
      this.refName = "content" + this.tabIndex;
    },
    // 获取订单信息
    getOrder() {
      let param = {
        messageId: this.scope[this.tabIndex].messageId,
        orderId: this.scope[this.tabIndex].orderId,
      };
      getEbayOrderInfo(param).then((res) => {
        if (res.code === 200) {
          this.tableDataOrderList = res.data.orderList;
        }
      });
    },
    /** 关闭备注编辑/产品资料弹窗 */
    isShowEdit() {
      this.editShow = false;
      this.lookShow = false;
    },
    /** 备注表格操作列按钮分发（编辑/删除） */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "edit") {
        this.editInfo(data.row);
      } else if (funType === "delete") {
        this.deleteInfo(data.row);
      }
    },
    /** 打开备注编辑弹窗并回显数据 */
    editInfo(data) {
      this.remarkObj = data;
      this.editShow = true;
    },
    /** 确认后删除订单备注 */
    deleteInfo(data) {
      this.$confirm("确定删除选中内容吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: data.id,
          };
          orderRemarkDelete(param).then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getRemarkList();
            }
          });
        })
        .catch(() => {});
    },
    /** 关闭页面并通知父组件刷新列表 */
    close() {
      this.$emit("isShowEdit");
      this.$emit("getList");
    },
    /** 基于后端列映射生成备注表格列定义 */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList);
      this.loading = false;
    },
    /** 分页查询订单备注列表 */
    getRemarkList() {
      orderRemarkList(this.pagination)
        .then((result) => {
          if (result.code == 200) {
            this.tableData = result.data.pageInfo;
            this.pagination.total = result.data.pageInfo.length;
            let label = result.data.renderList;
            if (label == null) {
              this.renderList = {};
            } else {
              Object.assign(this.renderList, label);
            }
            if (this.isFirst) {
              this.titleMap = result.data.titleMap;
              this.getTableLabel();
            }
          }
        })
        .catch((err) => {});
    },
    /** 查询 eBay 邮件往来详情 */
    getEbayMessage() {
      let param = {
        messageId: this.scope[this.tabIndex].messageId,
      };
      this.messageId = this.scope[this.tabIndex].messageId;
      getEbayMessage(param)
        .then((result) => {
          if (result.code == 200) {
            this.loading = false;
            this.leftEmailObj = result.data;
          }
        })
        .catch((err) => {});
    },
    getReplyInfo() {
      this.messageId = this.scope[this.tabIndex].messageId;
      let param = {
        messageId: this.scope[this.tabIndex].messageId,
        orderId: this.scope[this.tabIndex].orderId,
      };
      if (this.isDraft) {
        param.draftId = this.scope[this.tabIndex].draftId;
      }
      if (this.isSend) {
        param.sendId = this.scope[this.tabIndex].sendId;
      }
      replyMessageInfo(param)
        .then((result) => {
          if (result.code == 200) {
            this.loading = false;
            // 邮件附件
            this.imgSrc =
              result.data.DownloadUrl != ""
                ? result.data.DownloadUrl.split(",")
                : [];
            this.UploadingUrl = result.data.UploadingUrl;
            this.dataList = result.data.messageList
              ? result.data.messageList
              : [];
            this.templateList = result.data.template;
            // 回显上传的附件
            this.isIMg = true;
            const str = result.data.mediaName;
            // this.imgName = str !== "" ? str.split(",") : [];
            if (this.scope.length == 1) {
              let indexId = this.scope[0].messageId;
              let orderId = this.scope[0].orderId;
              let idInfo = "";
              if (this.dataList.length > 0) {
                for (let index = 0; index < this.dataList.length; index++) {
                  const element = this.dataList[index];
                  if (
                    element.messageId == indexId ||
                    orderId == element.orderNo
                  ) {
                    idInfo = index;
                    this.$set(element, "isActive", true);
                  } else {
                    this.$set(element, "isActive", false);
                  }
                }
                this.loading = false;
                this.leftEmailObj = this.dataList[idInfo];
                this.setReadList.push(this.dataList[idInfo].id);
                this.uploadObj.messageId = this.dataList[idInfo].messageId;
                this.dataObj.accountId = this.dataList[idInfo].accountId;
                this.dataObj.messageId = this.dataList[idInfo].messageId;
                this.dataObj.sendToName = this.dataList[idInfo].sendToName;
                this.dataObj.subject = this.dataList[idInfo].subject;
                this.messageId = this.dataList[idInfo].messageId;
                this.dataObj.recipients = this.dataList[idInfo].sender;
                this.dataObj.sender = this.dataList[idInfo].sendToName;
                if (this.tableDataOrderList.length > 0) {
                  this.dataObj.orderNo = this.tableDataOrderList[0].orderNo;
                }
              } else {
                if (this.isDraft) {
                  // 展示草稿箱信息
                  Object.assign(this.dataObj, result.data.draft);
                  this.dataObj.content = "";
                  const leftObj = result.data.draft;
                  this.setReadList.push(leftObj.id);
                  this.leftEmailObj = leftObj;
                  this.leftEmailObj.sendToName = leftObj.recipients;
                  this.leftEmailObj.text = leftObj.content;
                }
                if (this.isSend) {
                  // 展示已发送信息
                  Object.assign(this.dataObj, result.data.send);
                  this.dataObj.content = "";
                  const leftObj = result.data.send;
                  this.setReadList.push(leftObj.id);
                  this.leftEmailObj = leftObj;
                  this.leftEmailObj.sender = this.$getText(
                    leftObj.accountId,
                    this.dropList.ebayAccountList
                  );
                  this.leftEmailObj.sendToName = leftObj.recipients;
                  this.leftEmailObj.text = leftObj.content;
                }
              }
              this.getRemarkList();
            } else {
              for (let index = 0; index < this.dataList.length; index++) {
                const element = this.dataList[index];
                if (index == 0) {
                  this.$set(element, "isActive", true);
                } else {
                  this.$set(element, "isActive", false);
                }
              }
              this.leftEmailObj = this.dataList[0];
              this.setReadList.push(this.dataList[0].id);
              this.uploadObj.messageId = this.dataList[0].messageId;
              this.dataObj.accountId = this.dataList[0].accountId;
              this.dataObj.messageId = this.dataList[0].messageId;
              this.dataObj.sendToName = this.dataList[0].sendToName;
              this.dataObj.subject = this.dataList[0].subject;
              this.dataObj.recipients = this.dataList[0].sender;
              this.dataObj.sender = this.dataList[0].sendToName;
              if (this.tableDataOrderList.length > 0) {
                this.dataObj.orderNo = this.tableDataOrderList[0].orderNo;
              }
              this.getRemarkList();
            }
          }
        })
        .catch((err) => {});
    },

    /** 上传成功后记录图片名称并刷新详情回显 */
    getImgName(val) {
      val.forEach((item) => {
        this.imgName.push(item);
      });
      this.isIMg = true;
      this.getReplyInfo();
    },
    /** 删除已上传的附件图片 */
    handleDel(val, index) {
      const name = val.split(".")[0];
      delImg({ messageId: this.uploadObj.messageId, imgName: name }).then(
        (res) => {
          if (res.code === 200) {
            this.$message.success("删除成功！");
            this.imgName.splice(index, 1);
            this.getReplyInfo();
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.font-annex {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
.img-annex {
  width: 60px;
  height: 60px;
  margin-left: 10px;
  cursor: pointer;
}
// 邮件详情a标签禁止点击
.device-width > td #ImagePreview #imagePreviewHtml {
  div {
    table td {
      cursor: pointer;
    }
    .single-product-image {
      cursor: pointer;
    }
    table td > a {
      pointer-events: none !important;
    }
  }

  .fourColumnsTd {
    table td > a {
      pointer-events: none !important;
    }
  }
}
#imageExpandLink1 {
  pointer-events: none !important;
}
.device-width {
  pointer-events: none !important;
  a {
    pointer-events: none !important;
  }
}
.header-info {
  table td > a {
    pointer-events: none !important;
  }
  a {
    pointer-events: none !important;
  }
}
</style>
